import { List, Map } from "immutable";
import { fixMediaUrl, parseMetatagTitle, processRichText } from '../../Shared/api/drupal/drupalApi';
import { collectionBlock } from "../../Shared/components/ContentBlocks/CollectionBlock/CollectionBlockApiConversion";
import { activityClusterBlock, booksOverviewBlock, buttonBlock, carouselContentGridBlock, collectionSearchBarBlock, contentGridBlock, ctaBlock, emptyBlock, expandersBlock, faqBlock, featuredContentBlock, formstackBlock, gridBlock, highlightBlock, iframeBlock, imagesBlock, mediaBlock, newsletterSignupBlock, pageGridBlock, quoteBlock, recentNewsBlock, richTextBlock, subMenuBlock, subscriptionsBlock, vacancyOverviewBlock } from "./drupal_paragraph_to_block";
export const defaultParsedImages = {
    "1080x900": null,
    "1200x900": null,
    "1248x848": null,
    "1280w": null,
    "1280x720": null,
    "1600w": null,
    "16x9": null,
    "1880x1880": null,
    "195w": null,
    "195x195": null,
    "1x1": null,
    "200x140": null,
    "2496x1696": null,
    "300x210": null,
    "300x300": null,
    "360x300": null,
    "390h": null,
    "390x390": null,
    "400h_fb": null,
    "400w_fb": null,
    "400w": null,
    "400x280": null,
    "420x320": null,
    "440x440": null,
    "470x470": null,
    "4x3": null,
    "600x420": null,
    "600x600": null,
    "624x424": null,
    "720x600": null,
    "790x445": null,
    "800w_fb": null,
    "800w": null,
    "800x560": null,
    "840x640": null,
    "880x880": null,
    "940x940": null,
    crop_thumbnail: null,
    large: null,
    medium: null,
    thumbnail: null
};
/**
 * Converts the style URLs of a media image into a parsed styles object with fixed URLs.
 *
 * Iterates over the `style_urls` property of the provided `ParsedMediaImage` object,
 * applies `fixMediaUrl` to each valid URL, and returns a new `ParsedStyles` object.
 * If no style URLs are present, returns the default parsed images.
 *
 * @param media - The media image object containing style URLs to be fixed.
 * @returns A `ParsedStyles` object with fixed image URLs.
 */ const fixedImageStyles = (media)=>{
    var _media_field_media_image_image, _media_field_media_image;
    const style_urls = media === null || media === void 0 ? void 0 : (_media_field_media_image = media.field_media_image) === null || _media_field_media_image === void 0 ? void 0 : (_media_field_media_image_image = _media_field_media_image.image) === null || _media_field_media_image_image === void 0 ? void 0 : _media_field_media_image_image.style_urls;
    if (!style_urls) return defaultParsedImages;
    const styles = {
        ...defaultParsedImages
    };
    for (const [key, value] of Object.entries(style_urls)){
        if (!value) continue;
        styles[key] = fixMediaUrl(value);
    }
    return styles;
};
export const activityClustersPage = (n, c)=>({
        kind: "activityClusters",
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["400x280"]),
        imageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["4x3"]),
        imageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["800x560"]),
        phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
        phImageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]),
        phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
        imageAlt: n.field_media.field_media_image.alt,
        regions: Map(),
        selectedPeriod: null,
        selectedRegion: null,
        selectedCluster: 'none',
        selectPeriod: null,
        selectRegion: null,
        selectCluster: null,
        toggleArchive: null,
        showArchive: false,
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media)
    });
export const activityDetailPage = (n, c)=>({
        kind: "activityDetail",
        activityId: n.field_product_db_id,
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        subtitle: n.field_short_description,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: '',
        imageUrlLarge: '',
        phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
        phImageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]),
        phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
        imageAlt: n.field_media.field_media_image.alt,
        noticeTitle: n.field_notice_title,
        noticeContents: n.field_notice_contents,
        regions: Map(),
        selectedPeriod: null,
        selectedRegion: null,
        selectPeriod: null,
        selectRegion: null,
        blocks: generalContentPageBlocks(n.field_paragraphs, c),
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media)
    });
export const collectionPage = (n, c)=>({
        kind: "collection",
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: '',
        imageUrlLarge: '',
        phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
        phImageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]),
        phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
        imageAlt: n.field_media.field_media_image.alt,
        blocks: generalContentPageBlocks(n.field_paragraphs, c),
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media)
    });
export const locationDetailPage = (n, c)=>({
        kind: "locationDetail",
        locationId: n.field_sharepoint_locatie,
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["400x280"]),
        imageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["4x3"]),
        imageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["800x560"]),
        phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
        phImageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]),
        phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
        imageAlt: n.field_media.field_media_image.alt,
        currentTitle: n.field_current_title,
        currentContents: n.field_current_contents ? processRichText(n.field_current_contents) : "",
        aboutTitle: n.field_about_title,
        aboutContents: n.field_about_contents ? processRichText(n.field_about_contents) : "",
        openingHours: n.field_location_opening_hours,
        blocks: generalContentPageBlocks(n.field_paragraphs, c),
        region: undefined,
        contactCustomerSupport: n.field_contact_customer_service ? processRichText(n.field_contact_customer_service) : "",
        cookieUpdater: c,
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media),
        googlePlacesId: n.field_google_placeid
    });
export const newsletterSignupPage = (n, c)=>({
        kind: "newsletterSignup",
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: '',
        imageUrlLarge: '',
        phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
        phImageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]),
        phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
        imageAlt: n.field_media.field_media_image.alt,
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media)
    });
export const homePage = (n, c)=>({
        kind: "home",
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        headerButtonUrl: n.field_header_button_url ? n.field_header_button_url.url : "",
        headerButtonTitle: n.field_header_button_url ? n.field_header_button_url.title : "",
        imageUrl: '',
        imageUrlLarge: '',
        phImageUrlSmall: fixMediaUrl(n.field_media.field_media_image.image.style_urls["470x470"]),
        phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["940x940"]),
        phImageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]),
        phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1880x1880"]),
        imageAlt: n.field_media.field_media_image.alt,
        universalBlocks: generalContentPageBlocks(n.field_universal_paragraphs, c),
        blocks: generalContentPageBlocks(n.field_paragraphs, c),
        showAnnouncement: n.field_show_announcement,
        announcement: n.field_announcement,
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media)
    });
export const locationPage = (n, c)=>({
        kind: "locationContent",
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["400x280"]) : "",
        imageUrlFallback: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["4x3"]) : "",
        imageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["800x560"]) : "",
        phImageUrlSmall: n.field_media ? n.field_jumbo_small ? undefined : fixMediaUrl(n.field_media.field_media_image.image.style_urls["470x470"]) : '',
        phImageUrl: n.field_media ? n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["940x940"]) : '',
        phImageUrlFallback: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]) : '',
        phImageUrlLarge: n.field_media ? n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["1880x1880"]) : '',
        imageAlt: n.field_media ? n.field_media.field_media_image.alt : "",
        blocks: generalContentPageBlocks(n.field_paragraphs, c),
        buttonUrl: n.field_header_button_url ? n.field_header_button_url.url : undefined,
        buttonTitle: n.field_header_button_url ? n.field_header_button_url.title : undefined,
        jumboSize: n.field_jumbo_small ? "small" : "large",
        locationId: Number(n.field_location_id),
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media)
    });
export const locationOverviewPage = (n, c)=>({
        kind: "locationOverviewContent",
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["400x280"]) : "",
        imageUrlFallback: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["4x3"]) : "",
        imageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["800x560"]) : "",
        phImageUrlSmall: n.field_media ? n.field_jumbo_small ? undefined : fixMediaUrl(n.field_media.field_media_image.image.style_urls["470x470"]) : '',
        phImageUrl: n.field_media ? n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["940x940"]) : '',
        phImageUrlFallback: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]) : '',
        phImageUrlLarge: n.field_media ? n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["1880x1880"]) : '',
        imageAlt: n.field_media ? n.field_media.field_media_image.alt : "",
        blocks: generalContentPageBlocks(n.field_paragraphs, c),
        buttonUrl: n.field_header_button_url ? n.field_header_button_url.url : undefined,
        buttonTitle: n.field_header_button_url ? n.field_header_button_url.title : undefined,
        jumboSize: n.field_jumbo_small ? "small" : "large",
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media)
    });
export const generalContentPage = (n, c)=>({
        kind: "generalContent",
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["400x280"]) : "",
        imageUrlFallback: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["4x3"]) : "",
        imageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["800x560"]) : "",
        phImageUrlSmall: n.field_media ? n.field_jumbo_small ? undefined : fixMediaUrl(n.field_media.field_media_image.image.style_urls["470x470"]) : '',
        phImageUrl: n.field_media ? n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["940x940"]) : '',
        phImageUrlFallback: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]) : '',
        phImageUrlLarge: n.field_media ? n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["1880x1880"]) : '',
        imageAlt: n.field_media ? n.field_media.field_media_image.alt : "",
        blocks: generalContentPageBlocks(n.field_paragraphs, c),
        buttonUrl: n.field_header_button_url ? n.field_header_button_url.url : undefined,
        buttonTitle: n.field_header_button_url ? n.field_header_button_url.title : undefined,
        jumboSize: n.field_jumbo_small ? "small" : "large",
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media)
    });
export const blogPostPage = (n, c)=>({
        kind: "blogPost",
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        categories: n.field_blog_category.map((t)=>({
                name: t.label,
                slug: t.url
            })).toList(),
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["400x280"]) : "",
        imageUrlFallback: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["4x3"]) : "",
        imageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["800x560"]) : "",
        phImageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]) : "",
        phImageUrlFallback: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]) : "",
        phImageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]) : "",
        imageAlt: n.field_media ? n.field_media.field_media_image.alt : "",
        dateCreated: n.created,
        dateUpdated: n.changed,
        blocks: generalContentPageBlocks(n.field_paragraphs, c),
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media)
    });
export const blogOverviewPage = (n, c)=>({
        kind: "blogOverview",
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["400x280"]),
        imageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["4x3"]),
        imageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["800x560"]),
        phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
        phImageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]),
        phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
        imageAlt: n.field_media.field_media_image.alt,
        pageSize: 6,
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media)
    });
export const newsItemPage = (n, c)=>({
        kind: "newsItem",
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["400x280"]) : "",
        imageUrlFallback: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["4x3"]) : "",
        imageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["800x560"]) : "",
        phImageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]) : "",
        phImageUrlFallback: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]) : "",
        phImageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]) : "",
        imageAlt: n.field_media ? n.field_media.field_media_image.alt : "",
        dateCreated: n.created,
        dateUpdated: n.changed,
        blocks: generalContentPageBlocks(n.field_paragraphs, c),
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media)
    });
export const newsOverviewPage = (n, c)=>({
        kind: "newsOverview",
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["400x280"]),
        imageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["4x3"]),
        imageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["800x560"]),
        phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
        phImageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]),
        phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
        imageAlt: n.field_media.field_media_image.alt,
        pageSize: 6,
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media)
    });
export const generalContentPageBlocks = (paragraphs, onCookieChange)=>{
    return List(paragraphs.map((p)=>p.bundle == "text" ? richTextBlock(p) : p.bundle == "media" ? mediaBlock(p) : p.bundle == "faq_collection" ? faqBlock(p) : p.bundle == "expanders" ? expandersBlock(p) : p.bundle == "highlight" ? highlightBlock(p) : p.bundle == "knop" ? buttonBlock(p) : p.bundle == "images" ? imagesBlock(p) : p.bundle == "content_grid" ? contentGridBlock(p) : p.bundle == "caroussel" ? carouselContentGridBlock(p) : p.bundle == "collection" ? collectionBlock(p) : p.bundle == "subscription_block" ? subscriptionsBlock(p) : p.bundle == "books" ? booksOverviewBlock(p) : p.bundle == "vacancy_overview" ? vacancyOverviewBlock(p) : p.bundle == "featured_content" ? featuredContentBlock(p) : p.bundle == "activity_cluster" ? activityClusterBlock(p) : p.bundle == "quote" ? quoteBlock(p) : p.bundle == "collection_search_bar" ? collectionSearchBarBlock(p) : p.bundle == "page_grid" ? pageGridBlock(p) : p.bundle == "grid_block" ? gridBlock(p) : p.bundle == "recent_news" ? recentNewsBlock(p) : p.bundle == "formstack_block" ? formstackBlock(p) : p.bundle == 'iframe' ? iframeBlock(p, onCookieChange) : p.bundle == "cta_block" ? ctaBlock(p) : p.bundle == "newsletter_signup_form" ? newsletterSignupBlock(p) : p.bundle == "submenu" ? subMenuBlock(p) : p.bundle == "activities_selection_block" ? {
            kind: "activities_selection_block",
            ...p
        } : emptyBlock(p)));
};
export const reportOverview = (n, c)=>({
        kind: "reportOverview",
        pageTitle: parseMetatagTitle(n.metatag),
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["400x280"]),
        imageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["4x3"]),
        imageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["800x560"]),
        phImageUrlSmall: n.field_jumbo_small ? undefined : fixMediaUrl(n.field_media.field_media_image.image.style_urls["470x470"]),
        phImageUrl: n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["940x940"]),
        phImageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1x1"]),
        phImageUrlLarge: n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["1880x1880"]),
        imageAlt: n.field_media.field_media_image.alt,
        jumboSize: n.field_jumbo_small ? "small" : "large",
        buttonUrl: n.field_header_button_url ? n.field_header_button_url.url : undefined,
        buttonTitle: n.field_header_button_url ? n.field_header_button_url.title : undefined,
        isPreview: false,
        imageStyles: fixedImageStyles(n.field_media)
    });
